


























import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import AudienceCreativeDisplay from '@ui/AudienceCreative/AudienceCreativeDisplay'

settings =
  name: 'AudienceCreativeShow'

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'suppliers/:supplierId/audience_creatives/:audienceCreativeId'

  components: {
    LoadingIndicator,
    AudienceCreativeDisplay,
  }

  vue:
    data: ->
      modal:
        show: true

    computed:
      member: -> @$store.member
      supplierId: -> @member.supplier.id

      draftCount: ->
        @audience_creative?.stats.draft_availabilities_count

      publishedCount: ->
        @audience_creative?.stats.published_availabilities_count

    methods:
      hiClose: -> @$router.back()

      hiNavToEditStep: (step) ->
        params = { audienceCreativeId: @audience_creative.id }
        query = { step }
        @$router.push { name: 'AudienceCreativeEditPage', params, query }

export default VueOptions.vue settings
